import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import MovieIcon from "@mui/icons-material/Movie";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import TheatersIcon from "@mui/icons-material/Theaters";

interface PageContainerModel {
    children: any;
    active: number;
}

const PageContainer: any = ({ children, active }: PageContainerModel) => {
    const [value, setValue] = React.useState(active);
    const navigate = useNavigate();

    return (
        <>
            <Container
                maxWidth="md"
                sx={{ marginBottom: "72px" }}>
                {children}
            </Container>
            <Paper
                sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
                elevation={3}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}>
                    <BottomNavigationAction
                        label="Filme"
                        onClick={() => {
                            navigate("/movies");
                        }}
                        icon={<MovieIcon />}
                    />
                    <BottomNavigationAction
                        label="Serien"
                        onClick={() => {
                            navigate("/series");
                        }}
                        icon={<TheatersIcon />}
                    />
                    <BottomNavigationAction
                        label="Spiele"
                        onClick={() => {
                            navigate("/games");
                        }}
                        icon={<SportsEsportsIcon />}
                    />
                    <BottomNavigationAction
                        label="Bücher"
                        onClick={() => {
                            navigate("/books");
                        }}
                        icon={<MenuBookIcon />}
                    />
                </BottomNavigation>
            </Paper>
        </>
    );
};

export default PageContainer;
